import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-director-reports',
  templateUrl: './daily-director-reports.component.html',
  styleUrls: ['./daily-director-reports.component.scss']
})
export class DailyDirectorReportsComponent {

}
